import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
	selector: 'input-search',
	templateUrl: './input-search.component.html',
	styleUrls: ['./input-search.component.css'],
})
export class InputSearchComponent implements OnInit, AfterViewInit {
    @Input() public text: String;
    @Output() public onSearch = new EventEmitter();
    @ViewChild('inputFocus') searchElement: ElementRef;
    ngOnInit() {
        //this.text = "";
    }

    buscar(){
     this.text = this.text.trim();
        this.onSearch.emit(this.text);
    }

    ngAfterViewInit(){
        this.setFocus();
      }
    
      setFocus(){
        setTimeout(() => {
          this.searchElement.nativeElement.focus();
        }, 500);
      }

    /*cambiaText(text){
        this.text = text;
    }*/

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/controls/input-search/input-search.component.ts